import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow-left.svg'
import _imports_1 from '@/assets/img/arrow-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-1a7017e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between border-t border-solid border-gray-200" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "arrow"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 pl-3" }, "Previous", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Next", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "arrow",
  class: "pl-3"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { ref } from 'vue';

interface Props {
  pageCount: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    pageCount: null
  },
  emits: ["handlePaginate"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'handlePaginate', num: number): void;
}), expose: any, slots: any, attrs: any }) {




const page = ref<number>(1);

const handlePaginate = (e: number) => {
  page.value = e;
  emit('handlePaginate', e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePaginate(page.value - 1))),
      disabled: page.value === 1,
      class: _normalizeClass([{ 'opacity-50 cursor-not-allowed': page.value === 1 }, "flex items-center"])
    }, _hoisted_5, 10, _hoisted_2),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pageCount, (item, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          onClick: ($event: any) => (handlePaginate(item)),
          class: _normalizeClass(["px-3 text-gray-500 outline-none shadow-none focus:shadow-none focus:outline-none", { 'border-t-2 pt-5 border-pri text-pri': item === page.value }])
        }, _toDisplayString(item), 11, _hoisted_6))
      }), 128))
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePaginate(page.value + 1))),
      disabled: page.value === __props.pageCount,
      class: _normalizeClass([{
        'opacity-50 cursor-not-allowed': page.value === __props.pageCount,
      }, "flex items-center"])
    }, _hoisted_10, 10, _hoisted_7)
  ]))
}
}

})